import { FaHandshake, FaUsers } from "react-icons/fa";
import { FaDove } from "react-icons/fa6";
import { MdPublic } from "react-icons/md";
import blackStar from '../assets/shapes/black-star.png'

const ImpactStats = () => {
  const stats = [
    {
      icon: <FaHandshake className="text-4xl text-primary-green" />,
      number: "4597+",
      label: "People Rised",
    },
    {
      icon: <FaUsers className="text-4xl text-primary-green" />,
      number: "8945+",
      label: "Volunteer",
    },
    {
      icon: <FaDove className="text-4xl text-primary-green" />,
      number: "10M+",
      label: "Poor People Saved",
    },
    {
      icon: <MdPublic className="text-4xl text-primary-green" />,
      number: "100+",
      label: "Country Member",
    },
  ];

  return (
    <section className="py-6 px-[16px] sm:px-6 md:px-12 lg:px-20 bg-white relative overflow-x-hidden">
       <img src={blackStar} alt='black star' className="sm:w-16 w-10 sm:h-16 h-10 absolute top-[3%] right-[-1%]"/>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-[1380px] mx-auto">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-[#219D8014] flex flex-col items-center justify-center text-center px-6 py-8 rounded-lg shadow-sm"
          >
            {/* Circular icon with border accent */}
            <div className="relative w-20 h-20 flex items-center justify-center mb-4">
              <div className="absolute inset-0 rounded-full border-8 border-primary-green border-t-[#BFC1C2] border-l-[#BFC1C2]"></div>
              {stat.icon}
            </div>
            {/* Number */}
            <h3 className="text-4xl font-bold text-gray-900">{stat.number}</h3>
            {/* Label */}
            <p className="text-gray-600 mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ImpactStats;
